<template>
  <Badge v-on="$listeners" class="action-type-badge" :icon="icon">
    <span>{{ type === 'recurrent' ? isRecurrent : isTechnical }}</span>
  </Badge>
</template>

<script>
// Components
import Badge from 'Ui/AppBadge'

export default {
  name: 'ActionTypeBadge',

  components: {
    Badge,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    isTechnical() {
      if (this.card.technical) {
        return 'Técnica'
      } else {
        return 'No técnica'
      }
    },
    isRecurrent() {
      if (this.card.recurrent) {
        return 'Recurrente'
      } else {
        return 'Puntual'
      }
    },
    icon() {
      return this.type === 'recurrent' ? 'far fa-repeat' : 'far fa-tools'
    },
  },
}
</script>

<style scoped></style>
